// @flow
import * as React from 'react';

import styles from '../styles/Modal.scss';

type Props = {
  children: React.Node,
  isOpen: boolean,
  style?: Object,
}

class Modal extends React.Component<Props> {
  render() {
    return (
      <div className={this.props.isOpen ? styles.modal : styles.hidden}>
        <div className={styles.modalContent} style={this.props.style}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./client/src/components/Modal.jsx